import { useBrowseEnrichmentApi } from '@aibees/elephant/api/enrichment/use-browse-enrichment-api';
import { EXPORT_READ_API_PREFIX } from '@aibees/elephant/constants';
import { useBrowseSearchExports } from '@aibees/elephant/hooks/use-browse-search-exports';
import { HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';

interface RetryExportMutationApiProps {
  id: string;
  action: 'export' | 'enrichment';
}

export function useRetryExportMutationApi({
  id,
  action = 'export',
}: RetryExportMutationApiProps) {
  const workspaceId = useWorkspace()?.id ?? '';

  return useBaseMutation(
    {
      url: `${EXPORT_READ_API_PREFIX.replace(':wid', workspaceId).replace(
        ':id',
        id
      )}`,
      method: HttpMethod.post,
      params: {
        action: 'retry',
      },
    },
    {
      onSuccess: () => {
        if (action === 'export') {
          baseQueryClient.invalidateQueries([useBrowseSearchExports.name]);
        } else {
          baseQueryClient.invalidateQueries([useBrowseEnrichmentApi.name]);
        }
      },
    }
  );
}
